/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import styled from '@themes/theme'
import { ButtonStyles } from '@styles/button.style'
import { CommentsIco } from '@shared/Icon/EtcIcon'

export interface CommentButtonProps {
  id?: string
  className?: string
  onClick?: () => void
  hideStyle?: boolean
  count?: number
  disabled?: boolean
}

const CommentBtn = styled.button`
  ${ButtonStyles};
  z-index: 0;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 54px;
  height: 45px;
  margin: 8px 0 8px 10px;
  padding: 0;
  background: none;
  svg {
    width: 36px;
    height: 36px;
    path {
      fill: ${props => props.theme.color.disableBg};
    }
  }
  .num, .like-num {
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
    color: ${props => props.theme.color.btn};
  }
  &.active {
    svg .fill {
      fill: ${props => props.theme.color.underover};
    }
  }
  &.pick-bar-btn {
    height: 34px;
  }
  &:not(.pick-bar-btn){
    transform: translateX(-6px);
  }
`

export const CommentButton: React.FC<CommentButtonProps> = observer((props: CommentButtonProps) => {
  const { id, className, onClick, hideStyle = false, count = 0, disabled = false } = props
  return (
    <CommentBtn
      id={id}
      className={className}
      disabled={disabled}
      onClick={() => {
        if (onClick) {
          onClick()
        }
      }}
    >
      {!hideStyle && (
        <Fragment>
          <CommentsIco/>
          <span className="num">{count}</span>
        </Fragment>
      )}
    </CommentBtn>
  )
})
